import React from 'react';
import Button from './Button';
import { translate } from 'react-polyglot';

const ChatButton = ({ t, agentsAvailable }) =>
  <div className="text-center">
    {agentsAvailable
      ? <Button
          text={t('quality_chat_now')}
          handleClick={window.LC_API.open_chat_window}
        />
      : <Button
          text={t('quality_message')}
          type="outline"
          handleClick={window.LC_API.open_chat_window}
        />}
  </div>;

export default translate()(ChatButton);
